import React, { useState, useEffect } from "react";
import Logo from "./Logo";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const links = [
    { label: "Servicio", id: "como-funciona" },
    { label: "Precios", id: "precios" },
    { label: "Resultados", id: "datos" },
    { label: "Para quién", id: "para-quien" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-[#0A2342]/90 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
      data-testid="nav-header"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 md:h-20 flex items-center justify-between">
        <button
          onClick={() => scrollTo("hero")}
          className="shrink-0"
          data-testid="nav-logo-button"
          aria-label="MedBridge inicio"
        >
          <Logo variant="light" />
        </button>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              className="text-sm font-inter text-white/70 hover:text-white transition-colors tracking-wide"
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => scrollTo("contacto")}
            className="hidden md:inline-flex btn-gold px-5 py-2.5 rounded-full text-sm font-poppins font-semibold"
            data-testid="nav-cta-button"
          >
            Agenda llamada
          </button>
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden text-white p-2"
            aria-label="Menú"
            data-testid="nav-mobile-toggle"
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div
          className="lg:hidden bg-[#0A2342] border-t border-white/5 px-6 py-4 space-y-1"
          data-testid="nav-mobile-menu"
        >
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              className="block w-full text-left py-3 text-white/80 font-inter text-base"
              data-testid={`nav-mobile-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("contacto")}
            className="w-full btn-gold px-5 py-3 rounded-full text-sm font-poppins font-semibold mt-2"
            data-testid="nav-mobile-cta"
          >
            Agenda llamada
          </button>
        </div>
      )}
    </header>
  );
}
